import { partnerClient } from '@modules/core/services';
import { DEFAULT_STUDY_ID } from '../constants';
import { FetchSequencedSamplesOverviewParam } from '../types';
import { SequencedSamplesOverview } from '../types/overview.types';

export const fetchSequencedSamplesOverview = async (
  studyId = DEFAULT_STUDY_ID,
  params: Omit<FetchSequencedSamplesOverviewParam, 'studyId'>,
): Promise<SequencedSamplesOverview | undefined> => {
  const data = await partnerClient.get(`/studies/${studyId}/metrics/samples-sequenced-overview`, {
    params,
  });
  return data?.data;
};
